import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { useLocation, useNavigate } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import { URL } from "../../../Services/Constant";
import { get } from "../../../Services/ApiHandler";

const SiteViewProfile = ({ siteType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    mobile: "",
    role: "",
    adminId: "",
    password: "",
    confirmPassword: "",
    companyname: "",
    companycode: "",
    sitename: "",
    sitecode: "",
    sitelocation: "",
  });

  const [errors, setErrors] = useState({});

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);
  const [logo, setLogo] = useState();

  const type = location?.state?.type;

  const [locList, setLoclist] = useState([]);

  const getLocationList = () => {
    get(URL.COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (!formData.userName.trim()) newErrors.userName = "User Name is required";
    if (!formData.email.trim() || !emailRegex.test(formData.email))
      newErrors.email = "Valid Email is required";
    if (
      !formData.mobile.trim() ||
      !singaporeMobileRegex.test(formData.mobile)
    ) {
      newErrors.mobile = "Enter valid 8-digit Singapore number";
    }
    if (!formData.role) newErrors.role = "Select a role";
    if (!formData.adminId.trim()) newErrors.adminId = "Admin ID is required";
    if (!formData.password || formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    if (formData.confirmPassword !== formData.password)
      newErrors.confirmPassword = "Passwords do not match";
    if (!logo) newErrors.logo = "Company Logo is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("Submit successful", formData);
    }
  };

  const handleLogoChange = (event) => {
    const image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };

  const getView = (id) => {
    get(URL.SITE_VIEW + id)
      .then((res) => {
        let data = res?.data?.[0];
        let ob = {
          userName: "",
          email: "",
          mobile: "",
          role: "",
          adminId: "",
          password: "",
          confirmPassword: "",
          companyname: "",
          companycode: "",
          sitename: "",
          sitecode: "",
          sitelocation: "",
        };

        if (data?.site_name) {
          ob.sitename = data?.site_name;
        }

        if (data?.site_code) {
          ob.sitecode = data?.site_code;
        }

        if (data?.company_name) {
          ob.companyname = data?.company_name;
        }

        if (data?.company_code) {
          ob.companycode = data?.company_code;
        }

        if (data?.site_location) {
          ob.sitelocation = data?.site_location;
        }

        if (data?.site_address) {
          ob.address = data?.site_address;
        }

        if (data?.user_name) {
          ob.userName = data?.user_name;
        }

        if (data?.user_phone) {
          ob.mobile = data?.user_phone;
        }

        if (data?.user_email) {
          ob.email = data?.user_email;
        }

        if (data?.profile_image) {
          setLogo(data?.profile_image);
        }

        setFormData(ob);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (user_details?.knf_company_site_id) {
      getView(user_details?.knf_company_site_id);
    }
    getLocationList();
  }, []);

  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={type} />

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            {" "}
            Name
          </p>
          <input
            className="input-box"
            name="userName"
            value={formData.userName}
            onChange={handleChange}
            type="text"
            placeholder="User Name"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.userName && <p className="err">{errors.userName}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Email Id
          </p>
          <input
            className="input-box"
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            placeholder="Email"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Singapore Mobile Number
          </p>
          <input
            className="input-box"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            type="number"
            placeholder="+65 Mobile number"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>

        {logo ? (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Profile Image(size 2 MB)
            </p>

            <img
              src={
                logo ? (logo?.name ? URL.createObjectURL(logo) : logo) : logo
              }
              alt=""
              className="user"
            />
          </div>
        ) : (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Profile Image(size 2 MB)
            </p>
            <input
              className="input-box"
              name="logo"
              onChange={handleLogoChange}
              type="file"
              placeholder="Admin Profile Image"
              accept="image/*"
            />
            {errors.logo && <p className="err">{errors.logo}</p>}
          </div>
        )}

        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Company Name
          </p>
          <input
            className="input-box"
            name="company-name"
            value={formData.companyname}
            onChange={handleChange}
            type="text"
            placeholder="ABC Contruction"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.companyname && <p className="err">{errors.companyname}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Company Code
          </p>
          <input
            className="input-box"
            name="company-code"
            value={formData.companycode}
            onChange={handleChange}
            type="number"
            placeholder="Company Code"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.companycode && <p className="err">{errors.companycode}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Site Name
          </p>
          <input
            className="input-box"
            name="site-name"
            value={formData.sitename}
            onChange={handleChange}
            type="text"
            placeholder="Green villa "
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.sitename && <p className="err">{errors.sitename}</p>}
        </div>

        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Site Code
          </p>
          <input
            className="input-box"
            name="company-code"
            value={formData.sitecode}
            onChange={handleChange}
            type="number"
            placeholder="5688643"
            disabled={
              siteType == "show" ? true : type === "view" ? true : false
            }
          />
          {errors.sitecode && <p className="err">{errors.sitecode}</p>}
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            Site Location
          </p>
          <select
            name="location"
            value={formData?.sitelocation}
            className="input-box"
            type="text"
            disabled
          >
            <option>Select Location</option>
            {locList?.map((item) => {
              return (
                <option value={item?.id} key={item?.id}>
                  {item?.name}
                </option>
              );
            })}
          </select>
          {errors.sitelocation && <p className="err">{errors.sitelocation}</p>}
        </div>
      </div>
      {siteType !== "show" && (
        <div className="d-flex ac-jb mt-5">
          <button
            onClick={() => navigate("/site-profile")}
            className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            Back
          </button>

          <button
            onClick={handleSubmit}
            className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
          >
            {type == "edit" ? "Submit" : "Add"}
          </button>
        </div>
      )}
    </div>
  );
};

export default SiteViewProfile;
